import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ProductService } from 'services';
import { WhiteImage } from 'assets/img';
import { CloseWhiteIcon } from 'assets/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface Props {
	onClose?: any;
	item?: any;
	title?: string;
}

class ModalCreateProduct extends React.Component<Props> {

	state = {
		form: {
			name: '',
			category_id: '',
			description: '',
			presentation_id: '',
			price: '',
			long_description: ''
		},
		categories: [],
		presentations: [],
		photos: [],
		photos_deleted: []
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					category_id: this.props.item?.category_id || '',
					presentation_id: this.props.item?.presentation_id || '',
					price: this.props.item?.price || '',
					description: this.props.item?.description || '',
					long_description: this.props.item?.long_description || '',
				},
				photos: this.props.item?.photos || []
			});
		}

		this.load();
	}

	load = async () => {
		const res: any = await ProductService.admin.getCategories();
		this.setState({
			categories: res.categories,
			presentations: res.presentations
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.state.photos.length == 0) {
			Globals.showError("Debe ingresar al menos una foto del producto");
			return;
		}
		if (this.props.item != null) {
			await ProductService.admin.update({
				product_id: this.props.item?.id,
				...this.state.form,
				hasFile: true,
				photos: this.state.photos.filter((i: any) => i.id == null).map((i: any) => i?.value),
				photos_deleted: JSON.stringify(this.state.photos_deleted)
			});
			Globals.showSuccess("Se ha modificado el producto correctamente");
			this.props.onClose();
		}
		else {
			await ProductService.admin.create({
				...this.state.form,
				hasFile: true,
				photos: this.state.photos.map((i: any) => i?.value)
			});
			Globals.showSuccess("Se ha creado el producto correctamente");
			this.props.onClose();
		}
	}
	
	render() {
		return (
			<div id="modal-create-product">
				<TitleModalRight
					title={ this.props.title }
					onClose={ this.props.onClose }
				/>
				<form className="row" onSubmit={ this.submit }>
					<div className="col-md-12">
						<div className="container-photos" style={ this.state.photos.length > 0 ? { flexWrap: 'wrap' } : {} }>
							{
								this.state.photos.map((item: any,index) => {
									return (
										<div style={ this.state.photos.length > 0 ? { flex: .2 } : {} }>
											<PaperClip
												value={ null }
												successText={ `` }
												pendingText={ `` }
												width={ 1080 }
												height={ 1080 }
												onChange={ (e: any) => {
													let photos: any = [...this.state.photos];
													let photos_deleted: any = [...this.state.photos_deleted];
													if (item?.id != null) {
														photos_deleted.push(item?.id);
													}
													photos[index] = e.target;
													this.setState({
														photos,
														photos_deleted
													});
												} }>
												<div className="item-photo" style={{ backgroundImage: `url(${ item?.id != null ? (Constants.BASE_STORAGE + item?.file) : item.dataURL })` }}>
													{
														!item.dataURL && !item.id && (
															<img src={ item.dataURL || WhiteImage } />
														)
													}
													<button type="button" className="btn-delete" onClick={ async (e: any) => {
														e.stopPropagation();
														let photos: any = [...this.state.photos];
														let photos_deleted: any = [...this.state.photos_deleted];
														if (item?.id != null) {
															photos_deleted.push(item?.id);
														}
														photos.splice(index,1);
														await this.setState({
															photos,
															photos_deleted
														});
													} }>
														<img src={ CloseWhiteIcon } />
													</button>
												</div>
											</PaperClip>
										</div>
									)
								})
							}
							{
								this.state.photos.length < 5 && (
									<div style={ this.state.photos.length > 0 ? { flex: .2 } : {} }>
										<PaperClip
											value={ null }
											successText={ `` }
											pendingText={ `` }
											width={ 1080 }
											height={ 1080 }
											onChange={ (e: any) => {
												let photos: any = [...this.state.photos];
												photos.push(e.target);
												this.setState({
													photos
												});
											} }>
											<div className="item-photo">
												<img src={ WhiteImage } />
											</div>
										</PaperClip>
									</div>
								)
							}
							{
								this.state.photos.length == 0 && (
									<p className="message-images">Suba las imagenes del producto (Max. 5 imagenes). Tamaño requerido: 1080px por 1080px</p>
								)
							}
						</div>
					</div>
					<div className="col-md-6">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name" 
							placeholder="Nombre"
							onChange={ this.change } />
					</div>
					<div className="col-md-6">
						<Select
							placeholder="Categoría"
							name="category_id"
							onChange={ (e: any) => this.change(e) }
							value={ this.state.form.category_id }
							options={ this.state.categories.map((i: any) => {
								return {
									value: i.id,
									label: i.name
								}
							}) } />
					</div>
					<div className="col-md-12">
						<p className="label-quill">Descripción corta</p>
						<ReactQuill theme="snow" value={ this.state.form.description } onChange={(event) => {
							this.setState({
								form: {
									...this.state.form,
									description: event
								}
							});
						}} />
					</div>
					<div className="col-md-12">
						<p className="label-quill">Descripción larga</p>
						<ReactQuill theme="snow" value={ this.state.form.long_description } onChange={(event) => {
							this.setState({
								form: {
									...this.state.form,
									long_description: event
								}
							});
						}} />
					</div>
					<div className="col-md-6">
						<Select
							placeholder="Presentación"
							name="presentation_id"
							onChange={ (e: any) => this.change(e) }
							value={ this.state.form.presentation_id }
							options={ this.state.presentations.map((i: any) => {
								return {
									value: i.id,
									label: i.name
								}
							}) } />
					</div>
					<div className="col-md-6">
						<Input
							type="decimal"
							color="white"
							name="price"
							placeholder="Precio Unitario (US $)"
							value={ this.state.form.price }
							onChange={ (e: any) => this.change(e) } />
					</div>
					<div className="row row-buttons">
						<div className="col-md-6">
							<div className="text-center">
								<Button type="button" className="btn-cancel" onClick={ () => this.props.onClose() }>
									Cancelar
								</Button>
							</div>
						</div>
						<div className="col-md-6">
							<div className="text-center">
								<Button type="submit">
									Guardar
								</Button>
							</div>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreateProduct;